export const sendMessageToWebview = (message: string) => {
  try {
    // @ts-ignore
    window.webkit.messageHandlers.jsMessageHandler.postMessage(message);
  } catch (err) {
    console.error(err);
  }

  try {
    // @ts-ignore
    window.JSBridge.showMessageInNative(message);
  } catch (err) {
    console.error(err);
  }
};
